
export const AVAILABILITY = {
  OFFLINE: 'OFFLINE',
  ONLINE: 'ONLINE',
  DELETE: 'DELETE',
};

export const MEDIA_TYPE = {
 ONLN: "ONLN",
 EMAI: "EMAI",
 MAIL: "MAIL"
}
